export const ADMIN = 1;
export const MANAGER = 2;
export const USER = 3;
export const SUPER_ADMIN = 4;
export const ORGANIZATON_USER = 5;
